import React, { useEffect } from "react";
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Form, FormGroup, Label, Input, Button, Row, Col,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";


import {
    addNewExamRoom   as onAddExamRoom,
    updateExamRoom   as onUpdateExamRoom,
    resetExamRoomLastActionSuccess as OnResetExamRoomLastActionSuccess,
    
} from "store/actions";

const ExamRoomModal = ({ isOpen, toggle, isEdit, examRoom }) => {
    const dispatch = useDispatch();

    // 1. On récupère le flag 'success' du reducer
    const { success, error } = useSelector((state) => state.examRoomReducer);

    
    // 2. On surveille le changement du flag 'success'
    // Ferme le modal en cas de success
    useEffect(() => {
        // Si le dispatch dans onSubmit a réussi (success passe à true)
        if (success && isOpen) {
            toggle(); // On ferme le modal
            dispatch(OnResetExamRoomLastActionSuccess()); // On remet success à false immédiatement
        }
    }, [success, isOpen, toggle, dispatch]);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            name:        examRoom?.name        ?? "",
            name:        examRoom?.name        ?? "",
            code:        examRoom?.code        ?? "",
            capacity:    examRoom?.capacity    ?? "",
            description: examRoom?.description ?? "",
            is_active:   examRoom?.is_active   ?? true,
        },
        validationSchema: Yup.object({
            name:     Yup.string().required("Le nom est obligatoire"),
            code:     Yup.string().required("Le code est obligatoire"),
            capacity: Yup.number()
                .required("La capacité est obligatoire")
                .min(1, "La capacité doit être supérieure à 0"),
        }),
        onSubmit: (values) => {
            if (isEdit) {

                console.log("BEFORE UPDATE: ", examRoom);
                dispatch(onUpdateExamRoom({ ...values, uuid: examRoom.uuid }));
            } else {
                dispatch(onAddExamRoom(values));
            }
            //toggle();
        },
    });

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered backdrop={'static'} id="staticBackdrop">
            <ModalHeader toggle={toggle}>
                {isEdit ? "Modifier la salle" : "Nouvelle salle d'examen"}
            </ModalHeader>
            <ModalBody>
                <Form>
                    <Row>
                        <Col md={8}>
                            <FormGroup>
                                <Label>Nom de la salle *</Label>
                                <Input
                                    type="text"
                                    name="name"
                                    placeholder="Ex: Amphi A"
                                    value={validation.values.name}
                                    onChange={validation.handleChange}
                                    invalid={validation.touched.name && !!validation.errors.name}
                                />
                                {validation.touched.name && validation.errors.name && (
                                    <div className="text-danger small">{validation.errors.name}</div>
                                )}
                            </FormGroup>
                        </Col>
                        <Col md={4}>
                            <FormGroup>
                                <Label>Code *</Label>
                                <Input
                                    type="text"
                                    name="code"
                                    placeholder="Ex: AMP-A"
                                    value={validation.values.code}
                                    onChange={validation.handleChange}
                                    invalid={validation.touched.code && !!validation.errors.code}
                                />
                                {validation.touched.code && validation.errors.code && (
                                    <div className="text-danger small">{validation.errors.code}</div>
                                )}
                            </FormGroup>
                        </Col>
                    </Row>

                    <FormGroup>
                        <Label>Capacité (nombre de places) *</Label>
                        <Input
                            type="number"
                            name="capacity"
                            placeholder="Ex: 60"
                            value={validation.values.capacity}
                            onChange={validation.handleChange}
                            invalid={validation.touched.capacity && !!validation.errors.capacity}
                        />
                        {validation.touched.capacity && validation.errors.capacity && (
                            <div className="text-danger small">{validation.errors.capacity}</div>
                        )}
                    </FormGroup>

                    <FormGroup>
                        <Label>Description</Label>
                        <Input
                            type="textarea"
                            name="description"
                            rows={2}
                            placeholder="Description optionnelle..."
                            value={validation.values.description}
                            onChange={validation.handleChange}
                        />
                    </FormGroup>

                    <FormGroup check>
                        <Input
                            type="checkbox"
                            name="is_active"
                            checked={validation.values.is_active}
                            onChange={validation.handleChange}
                        />
                        <Label check>Salle active</Label>
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" outline onClick={toggle}>
                    Annuler
                </Button>
                <Button color="primary" onClick={validation.handleSubmit}>
                    {isEdit ? "Modifier" : "Créer"}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default ExamRoomModal;